// extracted by mini-css-extract-plugin
module.exports = {"image":"_18Bmuhm3FyN0En30nOoaHX"};